import { Component, OnInit } from '@angular/core';

import { BetaalverzoekService } from './betaalverzoek.service';

@Component({
    selector: 'betaalverzoek',
    templateUrl: './betaalverzoek.component.html',
    standalone: false
})
export class BetaalverzoekComponent implements OnInit {
    public showHeaderIcon: boolean;

    public constructor(private readonly betaalverzoekService: BetaalverzoekService) {}

    public ngOnInit() {
        this.betaalverzoekService.getShowHeaderIcon().subscribe((value) => (this.showHeaderIcon = value));
    }
}
